import React, { useState } from 'react';
import { Result } from 'antd';
import useTranslation from '@hooks/useTranslation';
import ConfettiExplosion from 'react-confetti-explosion';
import { useSelector } from 'react-redux';
import { selectTierChangeDirection } from '@src/app/reducers/checkout/checkoutSlice';
import StyledButton from '@components/form-control/styledButton/styledButton';

/**
 * Renders a success message with a brief confetti burst and a reload button.
 * @returns React.JSX.Element
 */
const SuccessView = () => {
  const t = useTranslation('Checkout.Modal');
  const tierChangeDirection = useSelector(selectTierChangeDirection);
  const [blast, setBlast] = useState(true);

  const handleReloadPage = () => {
    window.location.reload();
  };

  const getSuccessMessage = () => {
    switch (tierChangeDirection) {
      case 'upgrade':
        return t('UpgradeSuccessMessage');
      case 'downgrade':
        return t('DowngradeSuccessMessage');
      case 'same':
        return t('PlanUpdateSuccessMessage');
      default:
        return t('SuccessMessage');
    }
  };

  return (
    <div style={{ position: 'relative', minHeight: 340 }}>
      {blast && (
        <div style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)', top: 24 }}>
          <ConfettiExplosion duration={2500} particleCount={250} force={0.7} />
        </div>
      )}
      <Result 
        status="success" 
        title={getSuccessMessage()}
        subTitle={t('ReloadInstruction')}
        extra={[
          <StyledButton
            key="reload"
            title={t('ReloadPage')}
            onClick={handleReloadPage}
          />
        ]}
      />
    </div>
  );
};

export default SuccessView;


